import p from "./ghl-ui.es1506.js";
import w from "./ghl-ui.es1466.js";
import c from "./ghl-ui.es1505.js";
import { getDefaultOptions as k } from "./ghl-ui.es1513.js";
function C(O, e) {
  var l, r, a, i, n, d, v, u;
  w(1, arguments);
  var s = k(), o = c((l = (r = (a = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (n = e.locale) === null || n === void 0 || (d = n.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && a !== void 0 ? a : s.weekStartsOn) !== null && r !== void 0 ? r : (v = s.locale) === null || v === void 0 || (u = v.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && l !== void 0 ? l : 0);
  if (!(o >= 0 && o <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var t = p(O), f = t.getUTCDay(), m = (f < o ? 7 : 0) + f - o;
  return t.setUTCDate(t.getUTCDate() - m), t.setUTCHours(0, 0, 0, 0), t;
}
export {
  C as default
};
